import { useMutation } from '@tanstack/react-query';

import { PluginEquifaxInDepthTradingHistoryRequest } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { runEquifaxInDepthTradingHistoryRequest } from '../../requests/runEquifaxInDepthTradingHistoryRequest';

export const useRunEquifaxInDepthTradingHistoryRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginEquifaxInDepthTradingHistoryRequest) =>
      runEquifaxInDepthTradingHistoryRequest(constructPost, data),
    onSuccess: () => handleSuccess('Equifax request completed'),
    onError: () => handleError('Equifax request failed'),
  });
  return { runEquifaxInDepthTradingHistoryRequest: mutateAsync, ...rest };
};
